import styled from 'styled-components';

export const Form = styled.div`
  width: min(100%, 500px);
`;

export const WrapperFooter = styled.div`
  width: 100%;
  box-shadow: 0 1px 7px 0 rgba(201, 201, 201, 0.5);
`;

export const TitleCategory = styled.span`
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 1em;
  font-weight: 300;
  padding-bottom: 30px;
  padding-left: 16px;
  padding-top: 30px;
  margin-top: 16px;
  margin-bottom: 8px;
  width: 100%;
  background-color: #ffffff;
`;

export const BoxCard = styled.div`
  width: 100%;
  padding: 24px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 10px 26px rgb(0 0 0 / 5%);
  margin-bottom: 24px;
`;
